import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import LessonView from "@/pages/LessonView";
import Playground from "@/pages/Playground";
import Profile from "@/pages/Profile";
import AdminArea from "@/pages/Admin";
import Leaderboard from "@/pages/Leaderboard";
import Werbeseite from "@/pages/Werbeseite";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Challenges from "@/pages/Challenges";
import ChallengeDetail from "@/pages/ChallengeDetail";
import Lernpfad from "@/pages/Lernpfad";
import Flashcards from "@/pages/Flashcards";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/passwort-vergessen" element={<ForgotPassword />} />
          <Route path="/passwort-reset" element={<ResetPassword />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />

          {/* Öffentliche Seiten mit App-Layout */}
          <Route element={<AppLayout />}>
            <Route path="/kurse" element={<Courses />} />
            <Route path="/kurs/:slug" element={<CourseDetail />} />
          </Route>

          {/* Geschützte Seiten (Auth Guard + App-Layout) */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/kurs/:slug/lektion/:lessonId" element={<LessonView />} />
              <Route path="/playground" element={<Playground />} />
              <Route path="/bestenliste" element={<Leaderboard />} />
              <Route path="/werbeseite" element={<Werbeseite />} />
              <Route path="/challenges" element={<Challenges />} />
              <Route path="/challenges/:id" element={<ChallengeDetail />} />
              <Route path="/lernpfad" element={<Lernpfad />} />
              <Route path="/flashcards" element={<Flashcards />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/admin" element={<AdminArea />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
